import React from 'react'
import SkeletonWorkComment from '../../components/Skeleton/SkeletonWorkComment'
import { getExtensionFile, getNameInCapitalize } from '../../utils/common'
import date_format from './../../utils/date_format'
import { Trash } from 'iconoir-react'
import { RichText } from '../../components/common/CellText'
import FileItem from '../../components/FileItemComponent/FileItem'

const ListComment = props => {
  let { loadingCmt, commentList, setDeleteItem } = props
  return (
    <>
      {loadingCmt ? (
        <SkeletonWorkComment />
      ) : (
        <>
          {commentList?.map((item, index) => (
            <div key={index}>
              {item.deleted === true ? (
                <div
                  style={{ wordWrap: ' break-word' }}
                  className="bg-[rgba(0,115,199,0.02)] py-5 px-[14px] mt-[14px] rounded">
                  <div className="flex justify-between">
                    <div className="text-xs font-semibold leading-5 text-primaryText">
                      {getNameInCapitalize(item.name_uppercase)}
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="font-medium text-[8px] leading-[8px] text-lightText">
                        {date_format.renderTime(item.created_at)}
                      </div>
                      {item.deleted === true ? (
                        <div className="text-[10px] border border-red-500 px-[7px] rounded-full text-red-500 bg-[#fff8f8]">
                          Đã xóa
                        </div>
                      ) : (
                        <Trash
                          color="red"
                          width={12}
                          height={14}
                          onClick={() => {
                            setDeleteItem({
                              open: true,
                              id_comment: item.comment_id,
                            })
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="my-[14px] text-black text-[14px] leading-6 font-normal">
                    <RichText text={item.content} />
                  </div>
                  {item.files?.length > 0 &&
                    item.files
                      .map(file => ({
                        id: file.file_id,
                        name: file.file_name,
                      }))
                      .map(file => (
                        <FileItem
                          file={file}
                          key={file.id}
                          file_id={file.id}
                          file_name={file.name}
                          file_type={getExtensionFile(file.name)}
                        />
                      ))}
                </div>
              ) : (
                <div className="bg-[rgba(0,115,199,0.07)] py-5 px-[14px] mt-[14px] rounded">
                  <div className="flex justify-between">
                    <div className="text-xs font-semibold leading-5 text-primaryText">
                      {getNameInCapitalize(item.name_uppercase)}
                    </div>
                    <div className="flex items-center gap-4">
                      <div className="font-medium text-[8px] leading-[8px] text-lightText">
                        {date_format.renderTime(item.created_at)}
                      </div>
                      {item.deleted === true ? (
                        <div className="text-[10px] border border-red-500 px-[7px] rounded-full text-red-500 bg-[#fff8f8]">
                          Đã xóa
                        </div>
                      ) : (
                        <Trash
                          color="red"
                          width={12}
                          height={14}
                          onClick={() => {
                            setDeleteItem({
                              open: true,
                              id_comment: item.comment_id,
                            })
                          }}
                        />
                      )}
                    </div>
                  </div>
                  <div className="my-[14px] text-black text-[14px] leading-6 font-normal">
                    <RichText text={item.content} />
                  </div>
                  {item.files?.length > 0 &&
                    item.files
                      .map(file => ({
                        id: file.file_id,
                        name: file.file_name,
                      }))
                      .map(file => (
                        <FileItem
                          file={file}
                          key={file.id}
                          file_id={file.id}
                          file_name={file.name}
                          file_type={getExtensionFile(file.name)}
                        />
                      ))}
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </>
  )
}

export default ListComment
